<template>
    <form id="CourseForm" class="needs-validation" novalidate>
        <div class="row g-3">
            <!-- Course Name Field -->
            <div class="col-md-4">
                <label for="courseName"><strong>{{ $Translate('courseName') }}: </strong><span
                        class="text-danger">*</span></label>
                <input type="text" id="courseName" class="form-control"
                    :placeholder="$Translate('courseNamePlaceholder')"
                    :class="{ 'is-valid': courseSubmitted && courseNameIsValid, 'is-invalid': courseSubmitted && !courseNameIsValid }"
                    v-model="course.courseName" name="courseName" required />
            </div>

            <!-- From Date Field -->
            <div class="col-md-4">
                <label for="startDateCourse"><strong>{{ $Translate('startDate') }}:
                    </strong><span class="text-danger">*</span></label>
                <input type="date" id="startDateCourse" class="form-control"
                    :class="{ 'is-valid': courseSubmitted && startDateCourseIsValid, 'is-invalid': courseSubmitted && !startDateCourseIsValid }"
                    v-model="course.startDateCourse" name="startDateCourse" required />
            </div>

            <!-- To Date Field -->
            <div class="col-md-4">
                <label for="endDateCourse"><strong>{{ $Translate('endDate') }}:
                    </strong><span class="text-danger">*</span></label>
                <input type="date" id="endDateCourse" class="form-control"
                    :class="{ 'is-valid': courseSubmitted && endDateCourseIsValid, 'is-invalid': courseSubmitted && !endDateCourseIsValid }"
                    v-model="course.endDateCourse" name="endDateCourse" required />
            </div>

            <!-- Description Field -->
            <div class="col-md-4">
                <label for="descriptionCourse"><strong>{{ $Translate('description') }}:
                    </strong></label>
                <textarea id="descriptionCourse" class="form-control"
                    :class="{ 'is-valid': courseSubmitted && descriptionCourseIsValid, 'is-invalid': courseSubmitted && !descriptionCourseIsValid }"
                    v-model="course.descriptionCourse" name="descriptionCourse" />
            </div>
        </div>
    </form>
</template>

<script>
export default {
    name: 'Course',
    props: {
        course: Object,
        courseSubmitted: Boolean,
        courseList: Array,
        courseNameIsValid: Boolean,
        startDateCourseIsValid: Boolean,
        endDateCourseIsValid: Boolean,
        descriptionCourseIsValid: Boolean
    }
}
</script>

<style scoped>
.col-md-4 {
    text-align: start;
}

.col-md-4 label {
    margin-bottom: 10px;
}

.col-md-4 input,
.col-md-4 select,
.col-md-4 textarea {
    margin-bottom: 12px;
}

.col-md-4 select {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    background: url('../../../../dist/assets/select.svg') no-repeat right 0.75rem center;
    background-color: #fff;
    background-size: 16px 16px;
    padding-right: 2rem;
    line-height: 1.5;
    height: calc(1.5em + 0.75rem + 2px);
}
</style>